import { render, staticRenderFns } from "./ChangePasswordPanel.vue?vue&type=template&id=03c6aaf1&"
import script from "./ChangePasswordPanel.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports